import React from "react";
import { url } from "../../core/route/Route";
import { Spinner } from "../../core/ui/Spinner";
import { Page } from "../Page";
import { Icon } from "../../core/ui/icons";
import { api } from "../../api/api";


export function VerifyEmail(props: {

}) {

	const user = url.get("user");
	const token = url.get("token");

	const [success, setSuccess] = React.useState(false);
	const [error, setError] = React.useState("");

	React.useEffect(() => {
		api.register_verify({
			user,
			token,
		}).then((res: any) => {
			if (!res || !res.valid) {
				setError(res.detail ? res.detail : "Invalid");
			} else {
				setSuccess(true);
			}
		}).catch(() => {
			setError("Unable to verify at this time");
		});
	}, [token, user]);

	let msg;
	if (!user || !token || error) {
		msg = (
			<div className="bg-error text-inverse padding-5">
				Something has gone wrong
				<div>{error}</div>
			</div>
		);
	} else if (success) {
		msg = (
			<div className="flex vert">
				<Icon type="success_color" />
				<h2>Success</h2>
				<p>You can now login</p>
			</div>
		);
	
	} else {
		msg = (
			<div className="flex horiz gap-5">
				<Spinner size="small" />
				Please wait while we activte your account
			</div>
		);
	}

	return (
		<Page>
						
			<div className="flex vert width-100pc gap-20">
				<h1>Activating your account</h1>

				{msg}
			</div>

		</Page>
	);
}